<div class="groups-management-page" [class.groups-management-page--drawer-only]="drawerOnly">
  @if (!drawerOnly) {
  <div
    class="groups-management-content"
    [attr.inert]="isAnyModalVisible() ? '' : null"
    [attr.aria-hidden]="isAnyModalVisible()"
  >
    <div class="flex items-center justify-between mb-4">
      <h2 class="management-page-title">{{ 'groupsManagement.title' | translate }}</h2>
    </div>

    <!-- 4 Top Cards -->
    <div class="summary-cards mb-4 w-full grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-4">
      <bo-summary-card [title]="'groupsManagement.kpiTotal' | translate" iconBackground="#479e9c" titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal">
        <span summaryCardIcon><i class="pi pi-users"></i></span>
        <span summaryCardValue>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--value"></span>
          } @else {
          {{ summary.totalGroups | number }}
          }
        </span>
        <span summaryCardDescription class="text-[#22c55e]">
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--description"></span>
          } @else {
          +{{ summary.groupsGrowth | number }} {{ 'groupsManagement.kpiThisMonth' | translate }}
          }
        </span>
      </bo-summary-card>

      <bo-summary-card [title]="'groupsManagement.kpiNoAdmins' | translate" iconBackground="#c0392b" titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal">
        <span summaryCardIcon><i class="pi pi-exclamation-triangle"></i></span>
        <span summaryCardValue>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--value"></span>
          } @else {
          {{ summary.groupsWithoutAdmins | number }}
          }
        </span>
        <span summaryCardDescription>
          @if (!summaryLoading) {
          {{ 'groupsManagement.kpiNoAdminsNote' | translate }}
          }
        </span>
      </bo-summary-card>

      <bo-summary-card [title]="'groupsManagement.kpiMembers' | translate" iconBackground="#fca13b" titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal">
        <span summaryCardIcon>
          <img
            src="assets/layout/images/logo-bg-white.svg"
            class="summary-card-logo filter brightness-0 invert"
            alt=""
          />
        </span>
        <span summaryCardValue>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--value"></span>
          } @else {
          {{ summary.totalMembers | number }}
          }
        </span>
        <span summaryCardDescription>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--description"></span>
          } @else {
          {{ 'groupsManagement.kpiAcrossGroups' | translate }}
          }
        </span>
      </bo-summary-card>

      <bo-summary-card [title]="'groupsManagement.kpiActivities' | translate" iconBackground="#1f8554" titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal">
        <span summaryCardIcon>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="5" cy="5" r="2.5" fill="none"></circle>
            <circle cx="19" cy="5" r="2.5" fill="none"></circle>
            <circle cx="5" cy="19" r="2.5" fill="none"></circle>
            <circle cx="19" cy="19" r="2.5" fill="none"></circle>
            <line x1="7.5" y1="5" x2="16.5" y2="5"></line>
            <line x1="7.5" y1="19" x2="16.5" y2="19"></line>
            <line x1="5" y1="7.5" x2="5" y2="16.5"></line>
            <line x1="19" y1="7.5" x2="19" y2="16.5"></line>
          </svg>
        </span>
        <span summaryCardValue>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--value"></span>
          } @else {
          {{ summary.totalActivities | number }}
          }
        </span>
        <span summaryCardDescription>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--description"></span>
          } @else {
          {{ 'groupsManagement.kpiAcrossGroups' | translate }}
          }
        </span>
      </bo-summary-card>

      <bo-summary-card [title]="'groupsManagement.kpiTop' | translate" iconBackground="#d98324" titleClass="text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal">
        <span summaryCardIcon>
          <img src="assets/icons/trophy.svg" class="summary-card-trophy filter brightness-0 invert" alt="" />
        </span>
        <span summaryCardValue class="flex items-center gap-2">
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--sport"></span>
          } @else {
          <img
            [src]="sportIconPath(summary.topSportType)"
            class="summary-card-sport-icon filter brightness-0 invert"
            alt="{{ summary.topSportType }}"
          />
          {{ summary.topSportType }}
          }
        </span>
        <span summaryCardDescription>
          @if (summaryLoading) {
          <span class="summary-loading-line summary-loading-line--description"></span>
          } @else {
          {{ summary.topSportPercentage }}% {{ 'groupsManagement.kpiOfGroups' | translate }}
          }
        </span>
      </bo-summary-card>
    </div>

    <div class="management-panel w-full rounded-md p-4">
      <!-- Filters -->
      <div class="flex flex-col gap-3 mb-4">
        <div class="flex gap-4 items-center">
          <button type="button" (click)="toggleFilter()" class="filters-toggle-btn flex items-center gap-2 px-3 py-2 border border-[color:var(--surface-border)] rounded-md text-sm text-[color:var(--text-color)]">
            <i class="pi pi-filter"></i>{{ 'groupsManagement.filters' | translate }}<i class="pi text-[10px]" [ngClass]="showFilter ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </button>
          <div class="p-inputgroup w-96 search-bar">
            <span class="p-inputgroup-addon bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-r-0"><i class="pi pi-search"></i></span>
            <input pInputText [placeholder]="'groupsManagement.searchGroup' | translate" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChanged()" class="bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-l-0 focus:shadow-none"/>
          </div>
          <input
            pInputText
            [placeholder]="'groupsManagement.cityFilter' | translate"
            [(ngModel)]="cityFilter"
            (ngModelChange)="onCityFilterChanged()"
            class="groups-city-input bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] focus:shadow-none"
          />
          <button type="button" class="groups-quick-chip" [class.is-on]="withoutAdminsOnly" (click)="toggleWithoutAdmins()">
            {{ 'groupsManagement.withoutAdmins' | translate }}
          </button>
          <button type="button" class="groups-quick-chip" [class.is-on]="privateOnly" (click)="togglePrivateOnly()">
            {{ 'groupsManagement.privateOnly' | translate }}
          </button>
        </div>
        <div class="flex gap-4 items-end" *ngIf="showFilter">
          <div class="flex flex-col gap-2">
            <label class="text-[14px] font-medium text-[color:var(--text-color)]">{{ 'groupsManagement.sportTypeLabel' | translate }}</label>
            <div class="custom-dropdown">
              <p-dropdown
                [options]="sportTypes"
                [(ngModel)]="selectedSportType"
                (ngModelChange)="onFilterChanged()"
                optionLabel="label"
                optionValue="value"
                styleClass="w-[200px]"
                panelStyleClass="groups-sport-dropdown-panel"
              ></p-dropdown>
            </div>
          </div>
          <button pButton icon="pi pi-times" [label]="'groupsManagement.clearFilter' | translate" class="custom-clear-btn p-button-sm font-medium h-[40px] border-none text-white rounded-md px-4" (click)="clearFilter()"></button>
        </div>
      </div>

      <!-- Table -->
      <div class="custom-table">
        <p-table
          #groupsTable
          [value]="groups"
          [paginator]="true"
          [lazy]="true"
          [first]="tableFirst"
          [rows]="tableRows"
          [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 25, 50]"
          [showCurrentPageReport]="false"
          [sortField]="tableSortField"
          [sortOrder]="tableSortOrderValue"
          (onPage)="onTablePage($event)"
          (onLazyLoad)="onTableLazyLoad($event)"
          [loading]="tableLoading"
          styleClass="p-datatable-sm"
        >
          <ng-template pTemplate="paginatorleft">
            <span class="groups-pagination-report">{{ paginationReportText }}</span>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name">
                <div class="inline-flex flex-col items-center justify-center gap-1">
                  <span class="groups-table-header-label">{{ 'groupsManagement.groupName' | translate }}</span>
                  <p-sortIcon field="name"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="owner.displayName">
                <div class="inline-flex flex-col items-center justify-center gap-1">
                  <span class="groups-table-header-label">{{ 'groupsManagement.groupLead' | translate }}</span>
                  <p-sortIcon field="owner.displayName"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="sport">
                <div class="inline-flex flex-col items-center justify-center gap-1">
                  <span class="groups-table-header-label">{{ 'groupsManagement.sportType' | translate }}</span>
                  <p-sortIcon field="sport"></p-sortIcon>
                </div>
              </th>
              <th>
                <span class="groups-table-header-label">{{ 'groupsManagement.privacy' | translate }}</span>
              </th>
              <th>
                <span class="groups-table-header-label">{{ 'groupsManagement.adminsColumn' | translate }}</span>
              </th>
              <th pSortableColumn="totalSubgroups">
                <div class="flex flex-col items-center justify-center gap-1 text-center">
                  <span class="groups-table-header-label">{{ 'groupsManagement.total' | translate }}<br>{{ 'groupsManagement.subgroups' | translate }}</span>
                  <p-sortIcon field="totalSubgroups"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="totalMembers">
                <div class="flex flex-col items-center justify-center gap-1 text-center">
                  <span class="groups-table-header-label">{{ 'groupsManagement.total' | translate }}<br>{{ 'groupsManagement.members' | translate }}</span>
                  <p-sortIcon field="totalMembers"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="totalActivities">
                <div class="flex flex-col items-center justify-center gap-1 text-center">
                  <span class="groups-table-header-label">{{ 'groupsManagement.total' | translate }}<br>{{ 'groupsManagement.activities' | translate }}</span>
                  <p-sortIcon field="totalActivities"></p-sortIcon>
                </div>
              </th>
              <th>
                <div class="flex flex-col items-center justify-center gap-1">
                  <span class="groups-table-header-label">{{ 'groupsManagement.actions' | translate }}</span>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-group>
            <tr class="groups-row-hover transition-colors cursor-pointer" (click)="openSheet(group)">
              <td class="table-name-column text-[14px] font-normal text-[color:var(--text-color)] text-left" [attr.title]="null">
                <span class="flex flex-col min-w-0">
                  <span
                    class="table-text-cell"
                    [pTooltip]="group.name"
                    tooltipPosition="top"
                    tooltipStyleClass="management-name-tooltip"
                  >{{ group.name }}</span>
                  <span class="table-text-cell text-[11px] text-[color:var(--text-color-secondary)]" *ngIf="group.locationName">{{ group.locationName }}</span>
                </span>
              </td>
              <td class="text-left">
                <div class="flex items-center gap-3 min-w-0">
                  @if (getGroupLeadAvatarUrl(group)) {
                  <img
                    [src]="getGroupLeadAvatarUrl(group)"
                    [alt]="group.owner?.displayName || 'Group lead avatar'"
                    class="table-admin-avatar rounded-full flex-shrink-0 object-cover"
                    (error)="onGroupLeadAvatarError(group)"
                  />
                  } @else {
                  <div class="table-admin-avatar rounded-full bg-[color:var(--surface-hover)] text-[color:var(--text-color)] font-bold flex items-center justify-center text-sm flex-shrink-0">
                    {{ getGroupLeadInitial(group) }}
                  </div>
                  }
                  <div class="flex flex-col min-w-0">
                    <span
                      class="table-text-cell text-[color:var(--text-color)] text-[14px] font-normal"
                    >{{ group.owner?.displayName }}</span>
                    <span
                      class="table-text-cell text-[12px] text-gray-400"
                    >{{ group.owner?.email }}</span>
                  </div>
                </div>
              </td>
              <td class="text-left">
                <div class="flex items-center gap-2 text-[color:var(--text-color)] text-[14px] min-w-0">
                  <img *ngIf="getGroupSportIconSrc(group)" [src]="getGroupSportIconSrc(group)" class="table-sport-icon flex-shrink-0" alt="" />
                  <span
                    class="table-text-cell"
                  >{{ getGroupSportName(group) }}</span>
                </div>
              </td>
              <td class="text-center">
                <span class="groups-priv-chip" [class.is-public]="group.privacy !== 'private'">
                  {{ (group.privacy === 'private' ? 'groupsManagement.private' : 'groupsManagement.public') | translate }}
                </span>
              </td>
              <!-- Zero admins lights up: it is the 88% lever, group by group. -->
              <td class="text-center text-[14px] font-medium">
                <span [class.groups-admins-zero]="(group.adminsCount ?? 0) === 0" class="text-[color:var(--text-color)]">
                  {{ group.adminsCount ?? 0 }}
                </span>
              </td>
              <td class="text-center text-[color:var(--text-color)] text-[14px] font-medium">{{ group.totalSubgroups }}</td>
              <td class="text-center text-[color:var(--text-color)] text-[14px] font-medium">{{ group.totalMembers | number }}</td>
              <td class="text-center text-[color:var(--text-color)] text-[14px] font-medium">{{ group.totalActivities }}</td>
              <td class="text-center">
                <div class="flex items-center justify-center">
                  <button
                    type="button"
                    (click)="openEngage(group); $event.stopPropagation()"
                    class="table-action-btn table-action-btn--edit flex items-center justify-center rounded-md flex-shrink-0"
                    [pTooltip]="'groupsManagement.engageGroup' | translate"
                    tooltipPosition="left"
                    appendTo="body"
                  >
                    <i class="pi pi-megaphone text-[15px]"></i>
                  </button>
                  <button
                    type="button"
                    (click)="openEditDrawer(group, true); $event.stopPropagation()"
                    class="table-action-btn table-action-btn--edit flex items-center justify-center rounded-md flex-shrink-0"
                    [pTooltip]="'groupsManagement.editGroup' | translate"
                    tooltipPosition="left"
                    appendTo="body"
                  >
                    <svg class="table-edit-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                      <path
                        class="table-edit-icon-pencil-head"
                        d="M17.25 3.75L20.25 6.75L21.35 5.65C21.95 5.05 21.95 4.05 21.35 3.45L20.55 2.65C19.95 2.05 18.95 2.05 18.35 2.65L17.25 3.75Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    (click)="openDeleteDialog(group); $event.stopPropagation()"
                    class="table-action-btn table-action-btn--danger flex items-center justify-center rounded-md flex-shrink-0"
                    [pTooltip]="'groupsManagement.deleteGroup' | translate"
                    tooltipPosition="left"
                    appendTo="body"
                  >
                    <i class="pi pi-trash text-[16px]"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="groups-empty-row" [class.groups-empty-row--loading]="tableLoading">
              <td colspan="7">
                <div class="groups-empty-state">
                  @if (tableLoading) {
                  <span>{{ 'groupsManagement.loadingGroups' | translate }}</span>
                  } @else {
                  <span>{{ 'groupsManagement.noGroupsMatch' | translate }}</span>
                  }
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  } @if (deleteSuccessMessage) {
  <div class="management-toast management-toast--delete" role="status">
    <i class="pi pi-check"></i>
    <span [innerHTML]="deleteSuccessMessage"></span>
    <button type="button" class="management-toast-close" (click)="dismissDeleteSuccess()">
      <i class="pi pi-times"></i>
    </button>
  </div>
  }

  <bo-delete-confirm-dialog
    [visible]="deleteDialogVisible"
    [closing]="deleteDialogClosing"
    [restoreWithoutTransition]="skipDeleteDialogEnterAnimation"
    [confirmed]="deleteConfirmed"
    [targetLabel]="deleteTargetLabel"
    [targetName]="deleteTargetName"
    [errorMessage]="deleteDialogVisible ? operationErrorMessage : ''"
    (confirmedChange)="onDeleteConfirmationChange($event)"
    (closed)="closeDeleteDialog()"
    (hidden)="onDeleteDialogHidden()"
    (deleted)="confirmDelete()"
  />

  <bo-delete-group-with-incoming-dialog
    [visible]="deleteGroupWithIncomingDialogVisible"
    [closing]="deleteGroupWithIncomingDialogClosing"
    [restoreWithoutTransition]="skipDeleteGroupWithIncomingDialogEnterAnimation"
    [groupName]="deleteGroupWithIncomingGroupName"
    [incomingActivitiesCount]="deleteGroupWithIncomingCount"
    [confirmed]="deleteGroupWithIncomingConfirmed"
    (confirmedChange)="deleteGroupWithIncomingConfirmed = $event"
    (closed)="closeDeleteGroupWithIncomingDialog()"
    (hidden)="onDeleteGroupWithIncomingDialogHidden()"
    (deleteConfirmed)="onDeleteGroupWithIncomingDialogConfirmed()"
  />

  <!-- Edit Group Sidebar -->
  <p-sidebar
    [(visible)]="editDrawerVisible"
    position="right"
    [showCloseIcon]="false"
    [modal]="false"
    [dismissible]="false"
    [blockScroll]="false"
    [closeOnEscape]="false"
    [transitionOptions]="skipEditDrawerEnterAnimation ? '0ms' : '150ms cubic-bezier(0, 0, 0.2, 1)'"
    [baseZIndex]="drawerBaseZIndex"
    styleClass="edit-group-sidebar"
    [style]="{ top: '0', height: '100%' }"
    appendTo="body"
    (onHide)="onEditDrawerHidden()"
  >
    @for (draft of [editDraft]; track draft?.id) { @if (editDraft) {
    <div
      class="edit-drawer"
      [class.animate-slide-in]="!skipEditDrawerEnterAnimation"
      [attr.inert]="isGroupDrawerCovered() ? '' : null"
      [attr.aria-hidden]="isGroupDrawerCovered()"
      (click)="closeCoverPhotoMenu()"
    >
      <div class="edit-drawer-header">
        <button
          type="button"
          class="edit-drawer-close"
          [attr.aria-label]="groupDrawerBackLabel"
          (click)="closeEditDrawer()"
        >
          <i class="pi" [ngClass]="showGroupDrawerBackArrow ? 'pi-arrow-right' : 'pi-times'"></i>
        </button>
      </div>

      @if (operationErrorMessage && !isDeleteDialogActive() && !subgroupDrawerVisible && !isActivityDrawerVisible()) {
      <div class="edit-save-toast edit-save-toast--error" role="alert">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ operationErrorMessage }}</span>
        <button type="button" class="edit-save-toast-close" (click)="dismissOperationError(); $event.stopPropagation()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      } @else if (discardSuccessVisible) {
      <div class="edit-save-toast edit-save-toast--discard" role="status">
        <i class="pi pi-check"></i>
        <span>{{ 'groupsManagement.changesDiscarded' | translate }}</span>
        <button type="button" class="edit-save-toast-close" (click)="dismissDiscardSuccess(); $event.stopPropagation()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      } @else if (saveSuccessVisible) {
      <div class="edit-save-toast">
        <i class="pi pi-check"></i>
        <span>{{ 'groupsManagement.changesSaved' | translate }}</span>
        <button type="button" class="edit-save-toast-close" (click)="dismissSaveSuccess(); $event.stopPropagation()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      }

      <div class="edit-drawer-body" data-groups-drawer-body="group" (scroll)="onDrawerBodyScroll('group', $event)">
        <section class="edit-field-section">
          @if (editingName) {
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'groupsManagement.groupNameLabel' | translate }}</label>
            <button type="button" class="edit-undo-btn" (click)="undoGroupName(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>{{ 'groupsManagement.undo' | translate }}</span>
            </button>
          </div>
          <input
            pInputText
            class="edit-group-name-input"
            [class.edit-error]="!editDraft.name.trim()"
            [(ngModel)]="editDraft.name"
            (ngModelChange)="onModalDraftChanged()"
          />
          @if (!editDraft.name.trim()) {
          <small class="edit-error-text">{{ 'groupsManagement.nameRequired' | translate }}</small>
          }
          } @else {
          <div class="edit-drawer-header-content">
            <h2 class="view-group-title">{{ editDraft.name }}</h2>
            <button type="button" class="view-edit-btn" (click)="editGroupName()"><i class="pi pi-file-edit"></i> {{ 'groupsManagement.edit' | translate }}</button>
          </div>
          }
          <p class="edit-created-on" [class.edit-created-on--edit]="editingName">
            Created on {{ editDraft.createdOn }}
          </p>
        </section>

        <section class="edit-field-section">
          <label class="edit-field-label">{{ 'groupsManagement.coverPhoto' | translate }}</label>
          <div class="edit-cover-photo">
            <input
              #groupCoverPhotoInput
              class="edit-photo-file-input"
              type="file"
              accept="image/*"
              (change)="onCoverPhotoSelected($event)"
            />
            <img
              [src]="getCoverPhotoSrc()"
              alt="Group cover"
              class="edit-cover-photo-image"
              (error)="onCoverPhotoError($event, 'group')"
            />
            <button type="button" class="edit-cover-photo-btn" (click)="toggleCoverPhotoMenu($event)">
              <i class="pi pi-file-edit"></i>
              {{ 'groupsManagement.editPhoto' | translate }}
            </button>
            @if (coverPhotoMenuVisible) {
            <div class="edit-cover-photo-menu" (click)="$event.stopPropagation()">
              <button type="button" class="edit-cover-photo-menu-item" (click)="uploadCoverPhoto(groupCoverPhotoInput)">
                <i class="pi pi-upload"></i>
                {{ 'groupsManagement.uploadPhoto' | translate }}
              </button>
              <div class="edit-cover-photo-menu-divider" aria-hidden="true"></div>
              <button
                type="button"
                class="edit-cover-photo-menu-item edit-cover-photo-menu-item--danger"
                [disabled]="!hasCoverPhoto()"
                (click)="removeCoverPhoto()"
              >
                <i class="pi pi-trash"></i>
                {{ 'groupsManagement.removePhoto' | translate }}
              </button>
            </div>
            }
          </div>
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'groupsManagement.description' | translate }}</label>
            @if (editingDescription) {
            <button type="button" class="edit-undo-btn" (click)="undoDescription(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>{{ 'groupsManagement.undo' | translate }}</span>
            </button>
            } @else {
            <button type="button" class="view-edit-btn" (click)="editGroupDescription()"><i class="pi pi-file-edit"></i> {{ 'groupsManagement.edit' | translate }}</button>
            }
          </div>
          @if (editingDescription) {
          <textarea
            class="edit-description-input"
            [class.edit-error]="!editDraft.description.trim()"
            rows="4"
            [(ngModel)]="editDraft.description"
            (ngModelChange)="onModalDraftChanged()"
          ></textarea>
          @if (!editDraft.description.trim()) {
          <small class="edit-error-text">{{ 'groupsManagement.descriptionRequired' | translate }}</small>
          }
          } @else {
          <div class="view-description-box" [class.view-description-box--empty]="!hasDescription(editDraft.description)">
            {{ getDescriptionText(editDraft.description) }}
          </div>
          }
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">Website / External link</label>
            @if (editingWebsiteUrl) {
            <button type="button" class="edit-undo-btn" (click)="undoGroupWebsiteUrl(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>Undo</span>
            </button>
            } @else {
            <button type="button" class="view-edit-btn" (click)="editGroupWebsiteUrl()">
              <i class="pi pi-file-edit"></i> Edit
            </button>
            }
          </div>
          @if (editingWebsiteUrl) {
          <input
            class="edit-route-url-input"
            [class.edit-error]="isDraftWebsiteUrlInvalid(editDraft)"
            type="url"
            placeholder="https://example.com"
            [(ngModel)]="editDraft.websiteUrl"
            (ngModelChange)="onModalDraftChanged()"
          />
          @if (isDraftWebsiteUrlInvalid(editDraft)) {
          <small class="edit-error-text">Enter one valid website link only, starting with http:// or https://</small>
          } } @else if (hasWebsiteUrl(editDraft.websiteUrl)) {
          <a
            class="view-route-link"
            [href]="getWebsiteUrlText(editDraft.websiteUrl)"
            target="_blank"
            rel="noopener noreferrer"
            [title]="getWebsiteUrlText(editDraft.websiteUrl)"
            aria-label="Open website link in a new tab"
          >
            <i class="pi pi-link" aria-hidden="true"></i>
            <span>{{ getWebsiteUrlText(editDraft.websiteUrl) }}</span>
          </a>
          } @else {
          <div class="view-route-empty">
            <i class="pi pi-link" aria-hidden="true"></i>
            <span>No website link provided</span>
          </div>
          }
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'groupsManagement.sportTypeLabel' | translate }}</label>
            @if (editingSport) {
            <button type="button" class="edit-undo-btn" (click)="undoGroupSport(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>{{ 'groupsManagement.undo' | translate }}</span>
            </button>
            } @else {
            <button type="button" class="view-edit-btn" (click)="editGroupSport()"><i class="pi pi-file-edit"></i> {{ 'groupsManagement.edit' | translate }}</button>
            }
          </div>
          @if (editingSport) {
          <div class="edit-sport-dropdown custom-dropdown">
            <p-dropdown
              [options]="editGroupSportOptions"
              [ngModel]="getSelectedSportOptionValue(editDraft.sport)"
              (ngModelChange)="onEditSportChange($event)"
              optionLabel="label"
              optionValue="value"
              styleClass="w-full"
              panelStyleClass="groups-sport-dropdown-panel edit-group-sport-dropdown-panel edit-sport-options-panel"
            >
              <ng-template pTemplate="selectedItem" let-selected>
                @if (selected) {
                <div class="edit-sport-selected">
                  <img [src]="getSportIconPath(selected.label)" class="edit-sport-icon" alt="" />
                  <span>{{ selected.label }}</span>
                </div>
                }
              </ng-template>
              <ng-template pTemplate="item" let-option>
                <div
                  class="edit-sport-option"
                  [class.edit-sport-option--selected]="option.value === getSelectedSportOptionValue(editDraft.sport)"
                >
                  <img [src]="getSportIconPath(option.label)" class="edit-sport-icon" alt="" />
                  <span>{{ option.label }}</span>
                  @if (option.value === getSelectedSportOptionValue(editDraft.sport)) {
                  <i class="pi pi-check edit-sport-check"></i>
                  }
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          } @else {
          <div class="view-select-box view-sport-box">
            @if (getDraftSportIconPath(editDraft)) {
            <img [src]="getDraftSportIconPath(editDraft)" class="edit-sport-icon" alt="" />
            } @if (hasDraftSport(editDraft)) {
            <span>{{ editDraft.sport }}</span>
            }
          </div>
          }
        </section>

        <bo-readonly-lists
          [disabled]="isGroupEditActionMode()"
          [members]="getVisibleMembers(editDraft, membersExpanded)"
          [memberTotal]="getMemberListTotal(editDraft)"
          [membersExpanded]="membersExpanded"
          [membersMoreCount]="getMembersMoreCount(editDraft, membersExpanded)"
          [canToggleMembers]="canToggleMembersList(editDraft, membersExpanded)"
          [subgroups]="getVisibleSubgroups(editDraft, subgroupsExpanded)"
          [subgroupTotal]="getSubgroupListTotal(editDraft)"
          [subgroupsExpanded]="subgroupsExpanded"
          [subgroupsMoreCount]="getSubgroupsMoreCount(editDraft, subgroupsExpanded)"
          [canToggleSubgroups]="canToggleSubgroupsList(editDraft, subgroupsExpanded)"
          [activities]="getComputedActivities(editDraft)"
          [activityTotal]="getActivityListTotal(editDraft)"
          [activityStatusCounts]="getActivityStatusCounts(editDraft)"
          [activitiesExpanded]="activitiesExpanded"
          [activitiesMoreCount]="getActivitiesMoreCount(editDraft, activitiesExpanded)"
          [canToggleActivities]="canToggleActivitiesList(editDraft, activitiesExpanded)"
          [getSportIconPath]="sportIconPath"
          [getActivityLevelLabel]="activityLevelLabel"
          [getActivityTypeLabel]="apiActivityTypeLabel"
          (toggleMembers)="toggleMembersExpanded()"
          (toggleSubgroups)="toggleSubgroupsExpanded()"
          (toggleActivities)="toggleActivitiesExpanded($event)"
          (activityStatusSelected)="onActivityStatusSelected(editDraft, $event)"
          (subgroupOpened)="openSubgroupFromList($event)"
          (activityOpened)="openActivityFromList($event)"
          (thumbnailError)="onListThumbError($event)"
        />
      </div>

      <div class="edit-drawer-footer">
        <button type="button" class="edit-delete-group-btn" (click)="openDeleteFromEditDrawer()">
          <i class="pi pi-trash"></i>
          {{ 'groupsManagement.deleteThisGroup' | translate }}
        </button>
        @if (isGroupEditActionMode()) {
        <div class="edit-footer-actions">
          <button type="button" class="edit-discard-btn" (click)="discardEditChanges()">{{ 'groupsManagement.discardAll' | translate }}</button>
          <button type="button" class="edit-save-btn" [disabled]="!canSaveEditChanges()" (click)="saveEditChanges()">
            <i class="pi pi-save"></i>
            {{ 'groupsManagement.saveAll' | translate }}
          </button>
        </div>
        } @else {
        <button type="button" class="edit-close-btn" (click)="closeEditDrawer()">{{ 'groupsManagement.close' | translate }}</button>
        }
      </div>
    </div>
    } }
  </p-sidebar>

  <!-- Subgroup Sidebar -->
  <p-sidebar
    [(visible)]="subgroupDrawerVisible"
    position="right"
    [showCloseIcon]="false"
    [modal]="false"
    [dismissible]="false"
    [blockScroll]="false"
    [closeOnEscape]="false"
    [transitionOptions]="skipSubgroupDrawerEnterAnimation ? '0ms' : '150ms cubic-bezier(0, 0, 0.2, 1)'"
    [baseZIndex]="drawerBaseZIndex"
    styleClass="edit-group-sidebar"
    [style]="{ top: '0', height: '100%' }"
    appendTo="body"
    (onHide)="onSubgroupDrawerHidden()"
  >
    @for (draft of [subgroupDraft]; track draft?.id) { @if (subgroupDraft) {
    <div
      class="edit-drawer"
      [class.animate-slide-in]="!skipSubgroupDrawerEnterAnimation"
      [attr.inert]="isSubgroupDrawerCovered() ? '' : null"
      [attr.aria-hidden]="isSubgroupDrawerCovered()"
      (click)="closeSubgroupCoverPhotoMenu()"
    >
      <div class="edit-drawer-header">
        <button type="button" class="edit-drawer-close" aria-[label]="'groupsManagement.backDrawer' | translate" (click)="closeSubgroupDrawer()">
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>

      @if (operationErrorMessage && !isDeleteDialogActive() && !isActivityDrawerVisible()) {
      <div class="edit-save-toast edit-save-toast--error" role="alert">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ operationErrorMessage }}</span>
        <button type="button" class="edit-save-toast-close" (click)="dismissOperationError(); $event.stopPropagation()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      } @else if (subgroupDiscardSuccessVisible) {
      <div class="edit-save-toast edit-save-toast--discard" role="status">
        <i class="pi pi-check"></i>
        <span>{{ 'groupsManagement.changesDiscarded' | translate }}</span>
        <button type="button" class="edit-save-toast-close" (click)="dismissSubgroupDiscardSuccess(); $event.stopPropagation()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      } @else if (subgroupSaveSuccessVisible) {
      <div class="edit-save-toast">
        <i class="pi pi-check"></i>
        <span>{{ 'groupsManagement.changesSaved' | translate }}</span>
        <button type="button" class="edit-save-toast-close" (click)="dismissSubgroupSaveSuccess(); $event.stopPropagation()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      }

      <div
        class="edit-drawer-body"
        data-groups-drawer-body="subgroup"
        (scroll)="onDrawerBodyScroll('subgroup', $event)"
      >
        <section class="edit-field-section">
          @if (subgroupEditingName) {
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'groupsManagement.groupNameLabel' | translate }}</label>
            <button type="button" class="edit-undo-btn" (click)="undoSubgroupName(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>{{ 'groupsManagement.undo' | translate }}</span>
            </button>
          </div>
          <input
            pInputText
            class="edit-group-name-input"
            [class.edit-error]="!subgroupDraft.name.trim()"
            [(ngModel)]="subgroupDraft.name"
            (ngModelChange)="onModalDraftChanged()"
          />
          @if (!subgroupDraft.name.trim()) {
          <small class="edit-error-text">{{ 'groupsManagement.nameRequired' | translate }}</small>
          }
          } @else {
          <div class="edit-drawer-header-content">
            <h2 class="view-group-title">{{ subgroupDraft.name }}</h2>
            <button type="button" class="view-edit-btn" (click)="editSubgroupName()"><i class="pi pi-file-edit"></i> {{ 'groupsManagement.edit' | translate }}</button>
          </div>
          }
          <p class="edit-created-on" [class.edit-created-on--edit]="subgroupEditingName">
            Created on {{ subgroupDraft.createdOn }}
          </p>
        </section>

        <section class="edit-field-section">
          <label class="edit-field-label">{{ 'groupsManagement.coverPhoto' | translate }}</label>
          <div class="edit-cover-photo">
            <input
              #subgroupCoverPhotoInput
              class="edit-photo-file-input"
              type="file"
              accept="image/*"
              (change)="onSubgroupCoverPhotoSelected($event)"
            />
            <img
              [src]="getSubgroupCoverPhotoSrc()"
              alt="Group cover"
              class="edit-cover-photo-image"
              (error)="onCoverPhotoError($event, 'subgroup')"
            />
            <button type="button" class="edit-cover-photo-btn" (click)="toggleSubgroupCoverPhotoMenu($event)">
              <i class="pi pi-file-edit"></i>
              {{ 'groupsManagement.editPhoto' | translate }}
            </button>
            @if (subgroupCoverPhotoMenuVisible) {
            <div class="edit-cover-photo-menu" (click)="$event.stopPropagation()">
              <button
                type="button"
                class="edit-cover-photo-menu-item"
                (click)="uploadSubgroupCoverPhoto(subgroupCoverPhotoInput)"
              >
                <i class="pi pi-upload"></i>
                {{ 'groupsManagement.uploadPhoto' | translate }}
              </button>
              <div class="edit-cover-photo-menu-divider" aria-hidden="true"></div>
              <button
                type="button"
                class="edit-cover-photo-menu-item edit-cover-photo-menu-item--danger"
                [disabled]="!hasSubgroupCoverPhoto()"
                (click)="removeSubgroupCoverPhoto()"
              >
                <i class="pi pi-trash"></i>
                {{ 'groupsManagement.removePhoto' | translate }}
              </button>
            </div>
            }
          </div>
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'groupsManagement.description' | translate }}</label>
            @if (subgroupEditingDescription) {
            <button type="button" class="edit-undo-btn" (click)="undoSubgroupDescription(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>{{ 'groupsManagement.undo' | translate }}</span>
            </button>
            } @else {
            <button type="button" class="view-edit-btn" (click)="editSubgroupDescription()"><i class="pi pi-file-edit"></i> {{ 'groupsManagement.edit' | translate }}</button>
            }
          </div>
          @if (subgroupEditingDescription) {
          <textarea
            class="edit-description-input"
            [class.edit-error]="!subgroupDraft.description.trim()"
            rows="4"
            [(ngModel)]="subgroupDraft.description"
            (ngModelChange)="onModalDraftChanged()"
          ></textarea>
          @if (!subgroupDraft.description.trim()) {
          <small class="edit-error-text">{{ 'groupsManagement.descriptionRequired' | translate }}</small>
          }
          } @else {
          <div class="view-description-box" [class.view-description-box--empty]="!hasDescription(subgroupDraft.description)">
            {{ getDescriptionText(subgroupDraft.description) }}
          </div>
          }
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">Website / External link</label>
            @if (subgroupEditingWebsiteUrl) {
            <button type="button" class="edit-undo-btn" (click)="undoSubgroupWebsiteUrl(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>Undo</span>
            </button>
            } @else {
            <button type="button" class="view-edit-btn" (click)="editSubgroupWebsiteUrl()">
              <i class="pi pi-file-edit"></i> Edit
            </button>
            }
          </div>
          @if (subgroupEditingWebsiteUrl) {
          <input
            class="edit-route-url-input"
            [class.edit-error]="isDraftWebsiteUrlInvalid(subgroupDraft)"
            type="url"
            placeholder="https://example.com"
            [(ngModel)]="subgroupDraft.websiteUrl"
            (ngModelChange)="onModalDraftChanged()"
          />
          @if (isDraftWebsiteUrlInvalid(subgroupDraft)) {
          <small class="edit-error-text">Enter one valid website link only, starting with http:// or https://</small>
          } } @else if
          (hasWebsiteUrl(subgroupDraft.websiteUrl)) {
          <a
            class="view-route-link"
            [href]="getWebsiteUrlText(subgroupDraft.websiteUrl)"
            target="_blank"
            rel="noopener noreferrer"
            [title]="getWebsiteUrlText(subgroupDraft.websiteUrl)"
            aria-label="Open website link in a new tab"
          >
            <i class="pi pi-link" aria-hidden="true"></i>
            <span>{{ getWebsiteUrlText(subgroupDraft.websiteUrl) }}</span>
          </a>
          } @else {
          <div class="view-route-empty">
            <i class="pi pi-link" aria-hidden="true"></i>
            <span>No website link provided</span>
          </div>
          }
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'groupsManagement.sportTypeLabel' | translate }}</label>
            @if (subgroupEditingSport) {
            <button type="button" class="edit-undo-btn" (click)="undoSubgroupSport(); $event.stopPropagation()">
              <i class="pi pi-replay"></i>
              <span>{{ 'groupsManagement.undo' | translate }}</span>
            </button>
            } @else {
            <button type="button" class="view-edit-btn" (click)="editSubgroupSport()"><i class="pi pi-file-edit"></i> {{ 'groupsManagement.edit' | translate }}</button>
            }
          </div>
          @if (subgroupEditingSport) {
          <div class="edit-sport-dropdown custom-dropdown">
            <p-dropdown
              [options]="editGroupSportOptions"
              [ngModel]="getSelectedSportOptionValue(subgroupDraft.sport)"
              (ngModelChange)="onSubgroupSportChange($event)"
              optionLabel="label"
              optionValue="value"
              styleClass="w-full"
              panelStyleClass="groups-sport-dropdown-panel edit-group-sport-dropdown-panel edit-sport-options-panel"
            >
              <ng-template pTemplate="selectedItem" let-selected>
                @if (selected) {
                <div class="edit-sport-selected">
                  <img [src]="getSportIconPath(selected.label)" class="edit-sport-icon" alt="" />
                  <span>{{ selected.label }}</span>
                </div>
                }
              </ng-template>
              <ng-template pTemplate="item" let-option>
                <div
                  class="edit-sport-option"
                  [class.edit-sport-option--selected]="
                    option.value === getSelectedSportOptionValue(subgroupDraft.sport)
                  "
                >
                  <img [src]="getSportIconPath(option.label)" class="edit-sport-icon" alt="" />
                  <span>{{ option.label }}</span>
                  @if (option.value === getSelectedSportOptionValue(subgroupDraft.sport)) {
                  <i class="pi pi-check edit-sport-check"></i>
                  }
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          } @else {
          <div class="view-select-box view-sport-box">
            @if (getDraftSportIconPath(subgroupDraft)) {
            <img [src]="getDraftSportIconPath(subgroupDraft)" class="edit-sport-icon" alt="" />
            } @if (hasDraftSport(subgroupDraft)) {
            <span>{{ subgroupDraft.sport }}</span>
            }
          </div>
          }
        </section>

        <bo-readonly-lists
          [disabled]="isSubgroupEditActionMode()"
          [members]="getVisibleMembers(subgroupDraft, subgroupMembersExpanded)"
          [memberTotal]="getMemberListTotal(subgroupDraft)"
          [membersExpanded]="subgroupMembersExpanded"
          [membersMoreCount]="getMembersMoreCount(subgroupDraft, subgroupMembersExpanded)"
          [canToggleMembers]="canToggleMembersList(subgroupDraft, subgroupMembersExpanded)"
          [subgroups]="getVisibleSubgroups(subgroupDraft, subgroupSubgroupsExpanded)"
          [subgroupTotal]="getSubgroupListTotal(subgroupDraft)"
          [subgroupsExpanded]="subgroupSubgroupsExpanded"
          [subgroupsMoreCount]="getSubgroupsMoreCount(subgroupDraft, subgroupSubgroupsExpanded)"
          [canToggleSubgroups]="canToggleSubgroupsList(subgroupDraft, subgroupSubgroupsExpanded)"
          [activities]="getComputedActivities(subgroupDraft)"
          [activityTotal]="getActivityListTotal(subgroupDraft)"
          [activityStatusCounts]="getActivityStatusCounts(subgroupDraft)"
          [activitiesExpanded]="subgroupActivitiesExpanded"
          [activitiesMoreCount]="getActivitiesMoreCount(subgroupDraft, subgroupActivitiesExpanded)"
          [canToggleActivities]="canToggleActivitiesList(subgroupDraft, subgroupActivitiesExpanded)"
          [getSportIconPath]="sportIconPath"
          [getActivityLevelLabel]="activityLevelLabel"
          [getActivityTypeLabel]="apiActivityTypeLabel"
          (toggleMembers)="toggleSubgroupMembersExpanded()"
          (toggleSubgroups)="toggleSubgroupSubgroupsExpanded()"
          (toggleActivities)="toggleSubgroupActivitiesExpanded($event)"
          (activityStatusSelected)="onActivityStatusSelected(subgroupDraft, $event, true)"
          (subgroupOpened)="openSubgroupFromList($event)"
          (activityOpened)="openActivityFromList($event)"
          (thumbnailError)="onListThumbError($event)"
        />
      </div>

      <div class="edit-drawer-footer">
        <button type="button" class="edit-delete-group-btn" (click)="openSubgroupDelete()">
          <i class="pi pi-trash"></i>
          {{ 'groupsManagement.deleteThisGroup' | translate }}
        </button>
        @if (isSubgroupEditActionMode()) {
        <div class="edit-footer-actions">
          <button type="button" class="edit-discard-btn" (click)="discardSubgroupChanges()">{{ 'groupsManagement.discardAll' | translate }}</button>
          <button type="button" class="edit-save-btn" [disabled]="!canSaveSubgroupChanges()" (click)="saveSubgroupChanges()">
            <i class="pi pi-save"></i>
            {{ 'groupsManagement.saveAll' | translate }}
          </button>
        </div>
        } @else {
        <button type="button" class="edit-close-btn" (click)="closeNestedDrawers()">{{ 'groupsManagement.close' | translate }}</button>
        }
      </div>
    </div>
    } }
  </p-sidebar>

  <bo-activity-drawer-host
    [embeddedInGroups]="true"
    [dismissibleOnMaskClick]="true"
    [sportTypeConfigs]="sportTypeConfigs"
    [sportOptions]="editGroupSportOptions"
    [defaultCoverPhotoUrl]="defaultCoverPhotoUrl"
    [coveredByDialog]="isActivityDrawerCovered()"
    [externalOperationError]="operationErrorMessage"
    (externalOperationErrorChange)="onActivityOperationErrorChange($event)"
    (sessionChange)="onActivityDrawerSessionChange()"
    (visibilityChange)="onActivityVisibilityChange($event)"
    (deleteRequested)="onActivityDeleteRequested($event)"
    (activityDeleted)="onActivityDeleted($event)"
    (activityCancelled)="onActivityCancelled($event)"
    (activitySaved)="onActivitySaved($event)"
    (nestedDrawersCloseRequested)="closeNestedDrawers()"
  />
</div>


<p-sidebar
  [(visible)]="engageSidebarVisible"
  position="right"
  styleClass="group-engage-sidebar"
  [style]="{ width: 'min(38rem, 92vw)' }"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <h3 class="group-engage-title">{{ 'groupEngage.title' | translate }}</h3>
  </ng-template>
  <bo-group-engage
    *ngIf="engageGroupId"
    [groupId]="engageGroupId"
    [groupName]="engageGroupName"
    [sportName]="engageSportName"
  />
</p-sidebar>


<p-sidebar
  [(visible)]="sheetSidebarVisible"
  position="right"
  styleClass="group-engage-sidebar"
  [style]="{ width: 'min(46rem, 92vw)' }"
  appendTo="body"
>
  <bo-group-sheet
    *ngIf="sheetGroupId"
    [groupId]="sheetGroupId"
    (editRequested)="onSheetEdit()"
    (engageRequested)="onSheetEngage()"
    (deleteRequested)="onSheetDelete()"
  />
</p-sidebar>
